import { Address } from "@models/address/address";
import { EntityType } from "../common/entity-type.enum";
import { ExternalSourceType } from "./external-source-type.enum";
import { TrustSubType } from "../trusts/trusts-enums";

export class ShortEntityIdentityInfo {
  id: string;
  name: string;
  firstName: string;
  middleName1: string;
  middleName2: string;
  lastName: string;
  entityNumber: string;
  date?: string | undefined;
  address?: Address;
  source!: ExternalSourceType;
  type!: EntityType;
  din?: string;
  birthCity?: string;
  birthCountry?: string;
  trustSubType: TrustSubType | null;
  isVerified: boolean;

  constructor(init: Partial<ShortEntityIdentityInfo>) {
    this.id = init.id!;
    this.din = init.din;
    this.name = init.name!;
    this.firstName = init.firstName ?? '';
    this.middleName1 = init.middleName1 ?? '';
    this.middleName2 = init.middleName2 ?? '';
    this.lastName = init.lastName ?? '';
    this.address = init.address;
    this.entityNumber = init.entityNumber ?? '';
    this.date = init.date ?? '';
    this.source = init.source!;
    this.type = init.type!;
    this.birthCity = init.birthCity ?? '';
    this.birthCountry = init.birthCountry ?? '';
    this.trustSubType = init.trustSubType ?? null;
    this.isVerified = init.isVerified ?? false;
  }
}
